import React, { useState, useCallback } from 'react';
import { Box, Card, CardContent, IconButton, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { AuthenticatedImage } from './AuthenticatedImage';
export const FileGrid = (props) => {
  const { callbacks, files = [], selectedFile, showActions = false } = props;
  const { handleSelectFile, handleDeleteFile, handleDownloadFile } = callbacks;

  const [imageLoadStatus, setImageLoadStatus] = useState({});

  const handleImageLoadSuccess = useCallback((fileId) => {
    setImageLoadStatus((prev) => ({ ...prev, [fileId]: 'success' }));
  }, []);

  const handleImageLoadError = useCallback((fileId) => {
    setImageLoadStatus((prev) => ({ ...prev, [fileId]: 'error' }));
  }, []);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px',
      }}
    >
      {files?.map((file, index) => {
        const isClickable = imageLoadStatus[file.oid] === 'success' || showActions;

        return (
          <Box
            key={index}
            sx={{ overflow: 'hidden' }}
          >
            <Card
              sx={{
                position: 'relative',
                height: '170px',
                borderColor: 'lightgray',
                borderWidth: 1,
                borderStyle: 'solid',
                cursor: 'pointer',
                outline: '2px solid transparent',
                outlineOffset: '-2px',
                '&:hover': {
                  outlineColor: isClickable ? (theme) => theme.palette.primary.main : 'transparent',
                  '& .action-overlay': { opacity: 1 },
                },
                ...(file?.id === selectedFile?.id && {
                  outlineColor: (theme) => theme.palette.primary.main,
                }),
              }}
              onClick={() => isClickable && handleSelectFile(file)}
            >
              <CardContent
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  padding: 0,
                  '&:last-child': {
                    paddingBottom: 0,
                  },
                }}
              >
                <AuthenticatedImage
                  file={file.id}
                  previewId={file?.preview_file_id || file.oid}
                  alt={file.name}
                  onLoadSuccess={handleImageLoadSuccess}
                  onLoadError={handleImageLoadError}
                />
              </CardContent>
              {showActions && (
                <Box
                  className="action-overlay"
                  sx={{
                    position: 'absolute',
                    bottom: 8,
                    right: 8,
                    display: 'flex',
                    gap: 0.5,
                    opacity: 0,
                    transition: 'opacity 0.2s ease',
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(0,0,0,0.55)',
                      color: '#fff',
                      borderRadius: '6px',
                      padding: '4px',
                      '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.75)',
                      },
                    }}
                    onClick={() => handleDownloadFile(file)}
                  >
                    <FileDownloadIcon sx={{ fontSize: 17 }} />
                  </IconButton>

                  <IconButton
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(0,0,0,0.55)',
                      color: '#fff',
                      borderRadius: '6px',
                      padding: '4px',
                      '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.75)',
                      },
                    }}
                    onClick={() => handleDeleteFile(file)}
                  >
                    <DeleteOutlineIcon sx={{ fontSize: 17 }} />
                  </IconButton>
                </Box>
              )}
            </Card>
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                mt: 1,
              }}
            >
              {file?.name || '-'}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
